import { render, staticRenderFns } from "./CompanyViewInfoCard.vue?vue&type=template&id=d2326f64&"
import script from "./CompanyViewInfoCard.vue?vue&type=script&lang=js&"
export * from "./CompanyViewInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./CompanyViewInfoCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports